import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7b1bf00e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7b1bf00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1bf00e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1bf00e')) {
      api.createRecord('7b1bf00e', component.options)
    } else {
      api.reload('7b1bf00e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7b1bf00e&scoped=true&", function () {
      api.rerender('7b1bf00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4cbF6juT703ja/JS/comp/PopupBox.vue"
export default component.exports